module.exports = __webpack_public_path__ + "static/media/left.5515ef86.png";